/**
 * The page an emailed reset or invitation link opens on. One button; pressing
 * it spends the link. See confirmCopy() in @/lib/auth-redirect.
 */

import { esc, setPageTitle } from '@/lib/dom';
import { signInBrand } from '@/lib/host-branding';
import { authCardHeader } from '@/lib/auth-card';
import { confirmCopy, type PasswordPurpose } from '@/lib/auth-redirect';

export interface ConfirmLinkOptions {
  purpose: PasswordPurpose;
  hostname?: string;
  /** Spend the link. Resolves once signed in; rejects if the link is dead. */
  onContinue: () => Promise<void>;
}

export function renderConfirmLink(root: HTMLElement, opts: ConfirmLinkOptions): void {
  const brand = signInBrand(opts.hostname ?? location.hostname);
  const copy = confirmCopy(opts.purpose);
  setPageTitle(copy.title, brand.titleBase);

  root.innerHTML = `
    <div class="auth">
      <div class="auth-card" data-confirm-link="${esc(opts.purpose)}">
        ${authCardHeader(brand, copy.title)}
        <p class="auth-copy">${esc(copy.intro)}</p>
        <button type="button" class="btn-primary" data-action="confirm-link">${esc(copy.button)}</button>
      </div>
    </div>`;

  root.querySelectorAll<HTMLButtonElement>('[data-action="confirm-link"]').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.disabled = true;
      btn.textContent = 'One moment…';
      // The caller replaces this page on success and on failure alike.
      void opts.onContinue();
    });
  });
}
